import { domainEvent } from "@lookiero/messaging";
const GAME_PLAYED = "game_played";
const gamePlayed = ({ aggregateId }) => domainEvent({ aggregateId, name: GAME_PLAYED });
const isGamePlayed = (event) => event.name === GAME_PLAYED;
export { GAME_PLAYED, isGamePlayed, gamePlayed };
